import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import React, { useEffect, useState } from "react";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import { Icon, TextField, Autocomplete, CircularProgress, Stack } from "@mui/material";
import { useMaterialUIController } from "context";
import sample from "assets/images/sample.png";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import "react-image-crop/dist/ReactCrop.css";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { putAPICall, getAPICall } from "lib/callApi";
import { RESET_PASSWORD, USER_DETAIL, USER_PROFILE_PICTURE, USER } from "lib/constants";
import allTimezones from "lib/timezone_constants";
import { useDispatch } from "react-redux";
import CompanyHolidays from "components/CompanyAdminSettings/CompanyHolidays";
import CircularImage from "components/molecules/Images/CircularImage";
import { loginUserAction } from "../../redux/slice/users";

function ProfileSettings() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    password: {
      value: "",
      error: false,
      errorMessage: "",
    },
    confirmPassword: {
      value: "",
      error: false,
      errorMessage: "",
    },
  });
  const [userInfo, setUserInfo] = useState({});
  const [isTimezoneRequestLoading, setIsTimezoneRequestLoading] = useState(false);
  const [isBasicInfoRequestLoading, setIsBasicInfoRequestLoading] = useState(false);
  const [usersName, setUsersName] = useState();
  const [usersTimezone, setUsersTimezone] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const dispatch = useDispatch();

  const sidenavItems = [
    { icon: "person", label: "profile", href: "profile" },
    { icon: "receipt_long", label: "basic info", href: "basic-info" },
    { icon: "access_time", label: "Timezone", href: "timezone" },
    { icon: "calendar_today", label: "calendar", href: "calendar" },
    { icon: "lock", label: "reset password", href: "reset-password" },
  ];

  const renderSidenavItems = sidenavItems.map(({ icon, label, href }, key) => {
    const itemKey = `item-${key}`;

    return (
      <MDBox key={itemKey} component="li" pt={key === 0 ? 0 : 1}>
        <MDTypography
          component="a"
          href={`#${href}`}
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          sx={({
            borders: { borderRadius },
            functions: { pxToRem },
            palette: { light },
            transitions,
          }) => ({
            display: "flex",
            alignItems: "center",
            borderRadius: borderRadius.md,
            padding: `${pxToRem(10)} ${pxToRem(16)}`,
            transition: transitions.create("background-color", {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.shorter,
            }),

            "&:hover": {
              backgroundColor: light.main,
            },
          })}
        >
          <MDBox mr={1.5} lineHeight={1} color={darkMode ? "white" : "dark"}>
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
          {label}
        </MDTypography>
      </MDBox>
    );
  });

  const passwordRequirements = [
    "One special characters",
    "8 - 16 characters",
    "One number",
    "One upper case",
    "One lower case",
  ];

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });

  const changeHandler = async (event) => {
    const { name, value } = event.target;

    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$*.[\]{}()?\-"!@#%&,><':;|_~`+=/\\^])[A-Za-z\d^$*.[$*.[\]{}()?\-"!@#%&,><':;|_~`+=/\\^]{8,}$/.test(
        value
      )
    ) {
      setFormValues({
        ...formValues,
        [name]: {
          ...formValues[name],
          value,
          error: false,
          errorMessage: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: {
          ...formValues[name],
          value,
          error: true,
          errorMessage:
            "Password must contain 1 alphabet uppercase and lowecase both, 1 numeric value, 1 special character and must have 8 characters or longer",
        },
      });
    }
  };

  const onSubmit = async () => {
    let newFormValues = { ...formValues };
    const formFields = Object.keys(formValues);

    for (let index = 0; index < formFields.length; index += 1) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentValue === "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
            errorMessage: "Field is required",
          },
        };
      } else if (currentField === "confirmPassword") {
        if (
          currentValue.length !== formValues.password.value.length ||
          currentValue !== formValues.password.value
        ) {
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              error: true,
              errorMessage: "Password and confirm password must match",
            },
          };
        }
      }
    }

    setFormValues({ ...newFormValues });
    const foundErrorValue = Object.values(newFormValues).find((value) => value.error === true);

    if (!foundErrorValue) {
      const dataToPass = {
        password: newFormValues.password.value,
      };

      const result = await putAPICall(RESET_PASSWORD, true, dataToPass);

      if (result.data.success) {
        localStorage.clear();
        enqueueSnackbar(
          JSON.stringify({
            icon: "info",
            title: "Information",
            text: "Password reset successfully! Please do login again!",
          }),
          {
            variant: "custom",
          }
        );
        navigate("/sign-in");
      } else {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: result.data.message || "Something went wrong!",
          }),
          {
            variant: "custom",
          }
        );
      }
    }
  };

  const fetchUserInfo = async () => {
    const result = await getAPICall(USER_DETAIL, true);

    if (result.data.success) {
      dispatch(
        loginUserAction.getLoginUserData({
          ...result.data.data,
          profilePicture: result?.data?.data?.profilePicture || sample,
          defaultPermissionFilter: result?.data?.data?.defaultPermissionFilter
            ? JSON.stringify(result?.data?.data?.defaultPermissionFilter)
            : null,
          defaultTeamViewFilter: result?.data?.data?.defaultTeamViewFilter
            ? JSON.stringify(result?.data?.data?.defaultTeamViewFilter)
            : null,
          defaultLeaderboardFilter: result?.data?.data?.defaultLeaderboardFilter
            ? JSON.stringify(result?.data?.data?.defaultLeaderboardFilter)
            : null,
        })
      );

      setUserInfo({
        ...result.data.data,
        profilePicture: result?.data?.data?.profilePicture || sample,
        defaultPermissionFilter: result?.data?.data?.defaultPermissionFilter
          ? JSON.stringify(result?.data?.data?.defaultPermissionFilter)
          : null,
        defaultTeamViewFilter: result?.data?.data?.defaultTeamViewFilter
          ? JSON.stringify(result?.data?.data?.defaultTeamViewFilter)
          : null,
        defaultLeaderboardFilter: result?.data?.data?.defaultLeaderboardFilter
          ? JSON.stringify(result?.data?.data?.defaultLeaderboardFilter)
          : null,
      });
      setUsersName(result.data.data.name);
      setUsersTimezone(result.data.data.timezone);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (!userInfo) {
      fetchUserInfo();
    }
  }, [userInfo]);

  const updateBasicUserInfo = async () => {
    try {
      const response = await putAPICall(USER, true, { name: usersName, timezone: usersTimezone });
      if (response?.data?.success) {
        fetchUserInfo();
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Updated",
            text: "Data has been updated successfully!",
          }),
          {
            variant: "custom",
          }
        );
      } else {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Could not update the data, Please try again!",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      // console.log(error);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Could not update the data, Please try again!",
        }),
        {
          variant: "custom",
        }
      );
    } finally {
      setIsTimezoneRequestLoading(false);
      setIsBasicInfoRequestLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isTimezoneRequestLoading ? (
        <Stack alignItems="center">
          <CircularProgress
            sx={{
              position: "fixed",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}
            color="info"
            size="10vh"
          />
        </Stack>
      ) : (
        ""
      )}
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            {/* side nav */}
            <Card
              sx={{
                borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
                position: "sticky",
                top: "1%",
              }}
            >
              <MDBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={2}
                m={0}
                sx={{ listStyle: "none" }}
              >
                {renderSidenavItems}
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Card id="profile">
                    <MDBox p={2}>
                      <Grid container spacing={3} alignItems="center">
                        <Grid item>
                          <CircularImage
                            originalImgSrc={userInfo?.profilePicture}
                            alt="profile-pic"
                            allowUpload
                            allowRemove
                            newImgPrefix={userInfo?.email?.split?.(" ")?.join("-")}
                            onImageUploadSuccess={fetchUserInfo}
                            onImageRemovalSuccess={fetchUserInfo}
                            imageEndpoint={USER_PROFILE_PICTURE}
                          />
                        </Grid>
                        <Grid item>
                          <MDBox
                            height="100%"
                            sx={{ textTransform: "capitalize" }}
                            mt={0.5}
                            lineHeight={1}
                          >
                            <MDTypography
                              disabled={isTimezoneRequestLoading}
                              variant="h5"
                              fontWeight="medium"
                              sx={{ wordBreak: "break-all" }}
                            >
                              {userInfo.name || ""}
                            </MDTypography>
                            <MDTypography
                              variant="button"
                              sx={{ textTransform: "capitalize" }}
                              color="text"
                              fontWeight="medium"
                            >
                              {userInfo.type || ""}
                            </MDTypography>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card
                    id="basic-info"
                    sx={{
                      "& .MuiFormHelperText-root": { color: "#d32f2f" },
                    }}
                  >
                    {/* Basic info */}
                    <MDBox p={3}>
                      <MDTypography variant="h5">Basic Info</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3} px={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <MDInput
                            type="text"
                            label="Name"
                            variant="standard"
                            fullWidth
                            error={usersName?.length === 0 || usersName?.length > 100}
                            helperText={
                              // eslint-disable-next-line no-nested-ternary
                              usersName?.length === 0
                                ? "Please enter name"
                                : usersName?.length > 100
                                ? "Name cannot be more than 100 characters"
                                : ""
                            }
                            onChange={(event) => {
                              setUsersName(event.target.value);
                            }}
                            name="name"
                            value={usersName || ""}
                            InputLabelProps={{ shrink: true }}
                            placeholder={userInfo.name}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <MDInput
                            type="text"
                            label="Email"
                            disabled
                            variant="standard"
                            value={userInfo.email}
                            fullWidth
                            name="email"
                            InputLabelProps={{ shrink: true }}
                            placeholder={userInfo.email}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox p={3} sx={{ display: "flex", justifyContent: "end" }}>
                      <MDButton
                        disabled={isBasicInfoRequestLoading}
                        variant="gradient"
                        color="newColor"
                        onClick={() => {
                          if (usersName.length !== 0 && usersName.length <= 100) {
                            setIsBasicInfoRequestLoading(true);
                            updateBasicUserInfo();
                          }
                        }}
                      >
                        {isBasicInfoRequestLoading ? "Loading..." : "Update"}
                      </MDButton>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card
                    sx={{
                      "& .MuiFormHelperText-root": { color: "#d32f2f" },
                    }}
                  >
                    {/* Basic info */}
                    <MDBox p={3} id="timezone">
                      <MDTypography variant="h5">Timezone</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3} px={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                          <Autocomplete
                            disablePortal
                            fullWidth
                            disableClearable
                            getOptionLabel={(option) =>
                              `${option?.value || ""} ${
                                option?.title?.slice(0, option.title.indexOf(")") + 1) || ""
                              }`.trim()
                            }
                            id="combo-box-demo"
                            value={allTimezones.find((_) => _.value === usersTimezone) || ""}
                            onChange={(_, selectedTimezone) => {
                              setUsersTimezone(selectedTimezone.value);
                            }}
                            options={allTimezones}
                            renderInput={(params) => (
                              <TextField {...params} label="Select timezone" />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox p={3} sx={{ display: "flex", justifyContent: "end" }}>
                      <MDButton
                        disabled={isTimezoneRequestLoading}
                        variant="gradient"
                        color="newColor"
                        onClick={() => {
                          setIsTimezoneRequestLoading(true);
                          updateBasicUserInfo();
                        }}
                      >
                        {isTimezoneRequestLoading ? "Loading..." : "Update"}
                      </MDButton>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card
                    sx={{
                      "& .MuiFormHelperText-root": { color: "#d32f2f" },
                    }}
                    id="calendar"
                  >
                    <CompanyHolidays viewAsUserHoliday />
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card>
                    <Grid item xs={12} mt={2}>
                      <MDBox p={3}>
                        <MDTypography variant="h5">Reset Password</MDTypography>
                      </MDBox>
                      <MDBox
                        component="form"
                        pb={3}
                        px={3}
                        sx={{
                          "& .MuiFormHelperText-root": { color: "#d32f2f" },
                        }}
                        id="reset-password"
                      >
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <MDInput
                              fullWidth
                              label="New Password*"
                              inputProps={{ type: "password", autoComplete: "new-password" }}
                              error={formValues.password.error}
                              helperText={formValues.password.errorMessage}
                              onChange={(e) => changeHandler(e)}
                              name="password"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MDInput
                              fullWidth
                              label="Confirm New Password*"
                              inputProps={{ type: "password", autoComplete: "" }}
                              error={formValues.confirmPassword.error}
                              helperText={formValues.confirmPassword.errorMessage}
                              onChange={(e) => changeHandler(e)}
                              name="confirmPassword"
                            />
                          </Grid>
                        </Grid>
                        <MDBox mt={6} mb={1}>
                          <MDTypography variant="h5">Password requirements</MDTypography>
                        </MDBox>
                        <MDBox mb={1}>
                          <MDTypography variant="body2" color="text">
                            Please follow this guide for a strong password
                          </MDTypography>
                        </MDBox>
                        <MDBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="flex-end"
                          flexWrap="wrap"
                        >
                          <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
                            {renderPasswordRequirements}
                          </MDBox>
                          <MDBox ml="auto">
                            <MDButton
                              variant="gradient"
                              color="newColor"
                              size="small"
                              onClick={onSubmit}
                            >
                              update password
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ProfileSettings;
